import { OnInit, Directive } from "@angular/core";

import _get from 'lodash-es/get';

declare const wenji: IWenji;
import { Yii } from "libraries/interfaces/Yii";

import { ViewsService } from "libraries/view/views.service";
import { AppRootService } from "app/shared/services/app-root/app-root-service";
import { SashaEntryPoints } from "../sasha-entry-points";
import { IWenji } from "libraries/interfaces/IWenji";

/**
 * Not intended to be instanciated from a template
 * but it will contain all the code in common between the different routes
 * defined in sasha
 */
@Directive()
export abstract class SashaPageComponent implements OnInit {
    public permissionPath: string = "sasha.use";

    constructor(
        protected views: ViewsService,
        protected appRootService: AppRootService,
    ) {}

    public ngOnInit(): void {
        this.setAppName();
        this.views.getView('sasha');
        this.appRootService.setAppConfig({
            code: 'sasha',
            name: _get(wenji, 'sasha.name', 'Sasha'),
            routerLink: `/sasha/${SashaEntryPoints.home}`,
            tabs: [
                {
                    routerLink: `/sasha/${SashaEntryPoints.booking}`,
                    tabDetector: `/sasha/${SashaEntryPoints.booking}`,
                    label: Yii.t('wui-sasha-js', 'Dossiers'),
                    active: false,
                    allow: true,
                },
                {
                    routerLink: `/sasha/${SashaEntryPoints.processing}/search`,
                    tabDetector: `/sasha/${SashaEntryPoints.processing}`,
                    label: Yii.t('wui-sasha-js', 'Traitements'),
                    active: false,
                    allow: true,
                },
                {
                    routerLink: `/sasha/${SashaEntryPoints.ticketingReport}`,
                    tabDetector: `/sasha/${SashaEntryPoints.ticketingReport}`,
                    label: Yii.t('wui-sasha-js', "Journal d'émissions"),
                    active: false,
                    allow: true,
                    permission: 'sasha.ticketingReport.use'
                },
                {
                    routerLink: `/sasha/${SashaEntryPoints.processReport}`,
                    tabDetector: `/sasha/${SashaEntryPoints.processReport}`,
                    label: Yii.t('wui-sasha-js', "Journal des incidents"),
                    active: false,
                    allow: true,
                    permission: 'sasha.processReport.use'
                },
            ],
        });
    }

    protected setAppName(): void {
        const name: string = _get(wenji, 'sasha.name', 'Sasha');

        document.title = name;
        sessionStorage.setItem('childAppName', name);
    }
}
